import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import useAdminDashboardDoughnutChart from './AdminDashboardDoughnutChart.hook';
import { chartWrapper, chartTitle, loaderWrapper } from './AdminDashboardDoughnutChart.style';
import { AdminDashboardDoughnutChartDataPropsType } from './AdminDashboardDoughnutChart.types';
import Box from 'yoda-ui/components/Box';
import Loader from 'yoda-ui/components/Loader';
import { YodaColors, YodaFontSize } from 'yoda-ui/yodaTheme';

const COLORS = [YodaColors.gray9, YodaColors.gray2];

const AdminDashboardDoughnutChart: FC<AdminDashboardDoughnutChartDataPropsType> = ({
  title,
  doughnutData,
  loading = false,
}) => {
  const { t } = useTranslation();
  const { renderLabel } = useAdminDashboardDoughnutChart();

  return (
    <Box sx={ chartWrapper }>
      <Box sx={ chartTitle }>{ title }</Box>
      {
        loading
          ? <Box sx={ loaderWrapper }><Loader center/></Box>
          : doughnutData.length === 0
            ? <Box sx={ loaderWrapper }>{ t('maya_admin_dashboard_charts_no_data_title') }</Box>
            : <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={ doughnutData }
                  cx="50%"
                  cy="50%"
                  startAngle={ 90 }
                  endAngle={ -270 }
                  innerRadius={ 130 }
                  outerRadius={ 195 }
                  dataKey="percentage"
                  labelLine={ false }
                  label={
                    (props) => {
                      const labelData = renderLabel(props);
                      if (!labelData) return null;

                      return (
                        <text
                          x={ labelData?.x }
                          y={ labelData?.y }
                          fill={ YodaColors.white }
                          textAnchor="middle"
                          dominantBaseline="middle"
                          fontSize={ YodaFontSize.medium }
                          fontWeight="bold"
                        >
                          { `${doughnutData[0].percentage}%` }
                        </text>
                      );
                    }
                  }
                >
                  {
                    doughnutData.map((entry, index) => (
                      <Cell key={ `cell-${index}` } fill={ COLORS[index] } />
                    ))
                  }
                </Pie>
              </PieChart>
            </ResponsiveContainer>
      }
    </Box>
  );
};

export default AdminDashboardDoughnutChart;
